import constant from "./constant";
import foodLoader from "../assets/lotties/food-loader.json";
import catalogueLoader from "../assets/lotties/catalogue.json";
import { getTheme } from "../themes/themeManager";
import { THEME_PROPERTIES } from "../themes/themes.consts";

export const checkHandlerType = () => {
    if (window.location.href.includes("/catalogo")) {
        return constant.PRODUCT_TYPES.CATALOGUE;
    } else {
        return constant.PRODUCT_TYPES.MENU;
    }
};

export const handlerText = (t, key) => {
    if (window.location.href.includes("/catalogo")) {
        key = key + "_catalogue";
    }
    return t(key);
};

export const handlerGenericImage = (darkMode) => {
    if (!getTheme(THEME_PROPERTIES.IS_DEFAULT)) {
        return require("../themes/JET/assets/jet-item-trasnparent.png");
    }
    if (window.location.href.includes("/catalogo")) {
        return darkMode === true ? require("../assets/catalogue-pattern-dark.png") : require("../assets/catalogue-pattern.png");
    }
    return darkMode === true ? require("../assets/food-pattern-dark.png") : require("../assets/food-pattern.png");
};

export const handleLoader = () => {
    if (window.location.href.includes("/catalogo")) {
        return catalogueLoader;
    }
    return foodLoader;
};
